import { render } from "./ReportsItem.vue?vue&type=template&id=6705e1af"
import script from "./ReportsItem.vue?vue&type=script&lang=js"
export * from "./ReportsItem.vue?vue&type=script&lang=js"

import "./ReportsItem.vue?vue&type=style&index=0&id=6705e1af&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__